module.exports = __webpack_public_path__ + "static/media/borrower-img-general.d68fdba8.png";